export default __webpack_public_path__ + "images/1364d4b80318d8c4bb0016a3771672b6.svg";